import { noteIndex, usesFlats, getNoteName } from './theory';

// Tuning: Open G (Low to High: G, B, D, G, B, D)
// Index 0 = Lowest pitch string (rendered at bottom)
export const DOBRO_TUNING = [7, 11, 2, 7, 11, 2];

export const TOTAL_FRETS_DOBRO = 20;
export const INLAY_FRETS = [3, 5, 7, 9, 15, 17, 19];
export const DOUBLE_INLAY_FRETS = [12];

export const DOBRO_FORMULAS = {
  'Major':          [0, 2, 4, 5, 7, 9, 11],
  'Minor':          [0, 2, 3, 5, 7, 8, 10],
  'Maj Pentatonic': [0, 2, 4, 7, 9],
  'Min Pentatonic': [0, 3, 5, 7, 10],
  'Blues':          [0, 3, 5, 6, 7, 10],
  'Arp Major':      [0, 4, 7],
  'Arp Minor':      [0, 3, 7],
  'Arp Dom 7':      [0, 4, 7, 10],
  // Diatonic modes
  'Ionian':         [0, 2, 4, 5, 7, 9, 11],
  'Dorian':         [0, 2, 3, 5, 7, 9, 10],
  'Phrygian':       [0, 1, 3, 5, 7, 8, 10],
  'Lydian':         [0, 2, 4, 6, 7, 9, 11],
  'Mixolydian':     [0, 2, 4, 5, 7, 9, 10],
  'Aeolian':        [0, 2, 3, 5, 7, 8, 10],
  'Locrian':        [0, 1, 3, 5, 6, 8, 10],
};

/**
 * Builds nodes for scales and arpeggios across the entire fretboard.
 */
export function buildDobroNodes(rootName, formula, stringFocus, tonality = 'Major') {
  const rootIdx = noteIndex(rootName);
  const flats   = usesFlats(rootName, formula, tonality.toLowerCase());
  const nodes = [];

  DOBRO_TUNING.forEach((openStringIdx, stringIdx) => {
    if (!stringFocus[stringIdx]) return;

    for (let fret = 0; fret <= TOTAL_FRETS_DOBRO; fret++) {
      const noteIdx = (openStringIdx + fret) % 12;
      const interval = (noteIdx - rootIdx + 12) % 12;

      if (formula.includes(interval)) {
        nodes.push({
          string: stringIdx,
          fret,
          isRoot: interval === 0,
          interval,
          noteName: getNoteName(noteIdx, flats),
        });
      }
    }
  });

  return nodes;
}

/**
 * Builds nodes specifically for slide chord positions.
 * Straight Barre: Shows notes matching 1, 3, 5 across the fret containing the root on the low string.
 */
export function buildDobroChordNodes(rootName, shapeName, tonality, stringFocus) {
  const rootIdx = noteIndex(rootName);
  const nodes = [];

  if (shapeName === 'Straight Barre') {
    const isMajor = (tonality || 'Major') === 'Major';
    const chordIntervals = isMajor ? [0, 4, 7] : [0, 3, 7]; // Major or minor triad
    const flats   = usesFlats(rootName, null, isMajor ? 'major' : 'minor');

    DOBRO_TUNING.forEach((openStringIdx, stringIdx) => {
      if (!stringFocus[stringIdx]) return;

      for (let fret = 0; fret <= TOTAL_FRETS_DOBRO; fret++) {
        const noteIdx = (openStringIdx + fret) % 12;
        const interval = (noteIdx - rootIdx + 12) % 12;

        if (chordIntervals.includes(interval)) {
          nodes.push({
            string: stringIdx,
            fret,
            isRoot: interval === 0,
            interval,
            noteName: getNoteName(noteIdx, flats),
          });
        }
      }
    });
  }

  return nodes;
}
